import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import moment from "moment";

import "./MyProgressListing.scss";
import { getMyProgressList, resetField } from "../../../store/actions";
import ExerciseCard from "../../fitness/exercise/exerciseCard";
import PlaceholderIMG from "../../../sharedComponents/placeholderImage";
import NoExerciseImage from "../../../assets/images/exercise.png";
import NoPlanImage from "../../../assets/images/workout-plan.png";
import Loading from "../../../sharedComponents/preloader";

const myProgressTabs = [
	{ label: "monday", index: 1 },
	{ label: "tuesday", index: 2 },
	{ label: "wednesday", index: 3 },
	{ label: "thursday", index: 4 },
	{ label: "friday", index: 5 },
	{ label: "saturday", index: 6 },
	{ label: "sunday", index: 0 }
];

const MyProgressTabs = ({ history, getMyProgressList, myProgressData, resetField }) => {
	const [activeTab, setActiveTab] = useState(new Date().getDay());
	const [myProgressList, setMyProgressList] = useState([]);

	useEffect(() => {
		myProgressData && setMyProgressList(myProgressData);
	}, [myProgressData]);

	useEffect(() => {
		const currentTab = myProgressTabs.filter((item) => item.index === Number(activeTab));
		if (currentTab.length) {
			resetField("MyProgress.myProgressResult", null);
			setMyProgressList([]);
			getMyProgressList(currentTab[0].label);
		}
	}, [activeTab, getMyProgressList, resetField]);

	const openLogPanel = (event) => {
		const logDate = moment()
			.day(Number(activeTab))
			.isoWeek(moment().isoWeek());
		resetField("Exercises.exerciseToLog", { ...event, logDate });
		resetField("Exercises.toggleAddLogPanel", true);
	};

	return (
		<div className="tab-primary">
			<Tabs activeKey={activeTab} onSelect={(event) => setActiveTab(event)}>
				{myProgressTabs.map((item) => {
					const hasExercise = myProgressList && myProgressList.filter(item => item.data.length);
					return (
						<Tab key={item.index} eventKey={item.index} title={item.label}>
							{item.index === Number(activeTab) && myProgressList && myProgressList.length ? (
								myProgressList.map((plan, index) => {
									return plan && plan.label==='plan booked' && plan.data.length ? (
										<div key={index}>
											<div className="card-wrap">
												{plan.data.map((listItem, listIndex) => {
													return (
														<ExerciseCard
															key={listIndex}
															history={history}
															cardInfo={listItem.exercise}
															onClick={(event) => openLogPanel(event)}
															forceEnable
															logBtn
														/>
													);
												})}
											</div>
										</div>
									) : null;
								})
							) : null}

							{myProgressData && !hasExercise.length ? <div className="row my-3">
								<div className="col-6">
									<div className="my-3 p-4 text-center default-dashed-border pointer" onClick={() => resetField("Exercises.toggleAddExercisePanel", true)}>
										<PlaceholderIMG src={NoExerciseImage} />
										<h4 className="text-primary-dark mt-4">Add Exercise to My Plan</h4>
									</div>
								</div>
								<div className="col-6">
									<div className="my-3 p-4 text-center default-dashed-border pointer" onClick={() => resetField("MyWorkout.toggleAddPlanPanel", true)}>
										<PlaceholderIMG src={NoPlanImage} />
										<h4 className="text-primary-dark mt-4">Choose one of our Plans</h4>
									</div>
								</div>
							</div> : null}

							{!myProgressData ? <Loading /> : null}
						</Tab>
					)
				}
				)}
			</Tabs>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { UI, MyProgress } = state;
	return {
		myProgressData: get(MyProgress, "myProgressResult", null),
		atBottom: UI.atBottom
	};
};

const mapDispatchToProps = {
	getMyProgressList,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MyProgressTabs);
